import { Breadcrumb as AntBreadcrumb } from 'antd';
import styled from 'styled-components';

export const Breadcrumb = styled(AntBreadcrumb)`
  .ant-breadcrumb-separator {
    color: var(--scarlet-gray-100);
  }

  a {
    &:hover:not(:focus) {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: solid 1px;
    }
  }

  & > span:last-child a {
    color: var(--link-color);
  }
  & > ol > li > span.ant-breadcrumb-link > a {
    color: var(--link-color);
  }
`;
